import React, { useEffect } from "react";
import { constants } from "../../Shared/Url/Constants";
import axios from "axios";
import store from "../../store/store";
import { urlActions } from "../../store/store";
import { personActions } from "../../store/store";
import Cookies from "js-cookie";


const Login = ({ authStatusFun, emailFun, redirectFun, colleagueId }) => {
  useEffect(() => {
    checkAuth();
   // oktaAuth();
  }, []);

  const checkAuth = () => {
    let colleagueID = Cookies.get("colleagueID")
    console.log(colleagueID + "helppppp")
    if(colleagueID) {
      Cookies.set("csrf","123445555666ffgggg")
      authStatusFun(true);
      
    } else {
      console.log("Did not recieve the colleagueID!")
      store.dispatch(personActions.resetPersonState())
      authStatusFun(false);
      redirectFun();
      
    }
  }
 /* const oktaAuth = async () => {
    await axios({
      method: "GET",
      url: constants.OKTA_SSO,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.user.nameID) {
          emailFun(response.data.user.nameID);
        //  authStatusFun(true);
        } else {
        //  authStatusFun(false);
          redirectFun();
        }
      })
      .catch((error) => {
        console.log(error);
        authStatusFun(false);
        redirectFun();
      });
  }; */

  return <div>Login</div>;
};

export default Login;
